import { Component, OnDestroy, OnInit } from '@angular/core';
import { Login } from './models/login.model';
import { AuthenticationService } from './services/authentication.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { Subject, filter, takeUntil } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'FastTrackPortalUI';
  login = new Login("", "", "", "", "", "", 0, false, false, false, "");
  showError: boolean = false;
  errorMsg: string = "";
  passwordError: string = "";
  isLoggedIn: boolean = false;
  isAuthorized: boolean = false;
  fullname: string = "";
  shortName: string = "";
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(private _authService: AuthenticationService,
    private matDialog: MatDialog,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private route: Router,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.show("auth");
    this.msalService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.ACCOUNT_ADDED || msg.eventType === EventType.ACCOUNT_REMOVED),
      )
      .subscribe((result: EventMessage) => {
        if (this.msalService.instance.getAllAccounts().length === 0) {
          window.location.pathname = "/";
        } else {
          this.setLoginDisplay();

        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      })
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  authenticate(login: Login) {

    if (login.userId == "" && login.password == "") {
      this.errorMsg = "Please enter User Name!";
      this.passwordError = "Please enter Password!"
      return;
    }
    if (login.userId == "") {
      this.errorMsg = "Please enter User Name!";
      this.passwordError = "";
      return;
    }
    if (login.password == "") {
      this.errorMsg = "";
      this.passwordError = "Please enter Password!"
      return;
    }
    if (login.password != login.password.trim()) {
      this.errorMsg = "The username and/or password entered is invalid,please try again or contact HSR at 1.800.328.1114";
      this.passwordError = "";
      return;
    }

    this._authService.authenticate(login).subscribe({
      next: (res: any) => {

        if (res.body) {
          this.errorMsg = "";
          this.passwordError = "";
          this.login.firstName = res.body.user.firstName;
          this.login.lastName = res.body.user.lastName;
          this.login.userRole = res.body.userRole;
          this.login.accessId = res.body.user.accessID;
          this.login.userId = res.body.user.userID;
          this.login.isCampus = res.body.isCampus;
          this.login.isDISD = res.body.isDISD;
          this.login.isRoster = res.body.isRoster;
          this.login.accessLevel = res.body.user.accessLevel;

          this._authService.isAuthUser.next(res.status);

          this._authService.isAuthUser.subscribe((value) => {
            this.isLoggedIn = value;
            this.fullname = this.login.firstName.trim() + " " + this.login.lastName.trim();

            if (this.fullname != null || this.fullname != '') {
              const names = this.fullname.split(' ');
              let shortName = names[0].substring(0, 1) + names[1].substring(0, 1);
              this.shortName = shortName.toUpperCase();
            }
          });

          this._authService.setLogin.next(this.login);
          this.route.navigate(['search-for-students']);





        }
        else {
          this.errorMsg = "The username and/or password entered is invalid,please try again or contact HSR at 1.800.328.1114";
          this.passwordError = "";
        }
      }
    })
  }
  logout() {
    this.msalService.logout();
    this._authService.isAuthUser.next(false);
    this.login = new Login("", "", "", "", "", "", 0, false, false, false, "");
    this.isLoggedIn = false;
    this.isAuthorized = false;
    this.route.navigate(['home']);
  }


  setLoginDisplay() {
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.msalService.instance.getActiveAccount();
    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      let accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);

      this.isLoggedIn = true;
      let loggedInUser = new Login(accounts[0].username, "", "", "", "", "", 0, false, false, false, "");
      this.getAccess(loggedInUser, accounts[0].name!);
    }
    else if (activeAccount) {
      this.isLoggedIn = true;
      let loggedInUser = new Login(activeAccount.username, "", "", "", "", "", 0, false, false, false, "");
      this.getAccess(loggedInUser, activeAccount.name!);
    }
  }

  getAccess(login: Login, adName: string) {

    if (adName) {
      this.fullname = adName;
      const names = this.fullname.split(' ');
      if (names && names.length > 1) {
        let shortName = names[0].substring(0, 1) + names[1].substring(0, 1);
        this.shortName = shortName.toUpperCase();
      }
    }

    this._authService.authorize(login).subscribe({
      next: (res: any) => {
        if (res.body) {
          if (res.body.user.active) {
            this.errorMsg = "";
            this.passwordError = "";
            this.login.firstName = res.body.user.firstName;
            this.login.lastName = res.body.user.lastName;
            this.login.userRole = res.body.userRole;
            this.login.accessId = res.body.user.accessID;
            this.login.userId = res.body.user.userID;
            this.login.isCampus = res.body.isCampus;
            this.login.isDISD = res.body.isDISD;
            this.login.isRoster = res.body.isRoster;
            this.login.accessLevel = res.body.user.accessLevel;

            this._authService.isAuthUser.next(res.status);

            this._authService.isAuthUser.subscribe((value) => {
              this.isLoggedIn = value;
              this.isAuthorized = value;
              this.fullname = this.login.firstName.trim() + " " + this.login.lastName.trim();

              if (this.fullname != null || this.fullname != '') {
                const names = this.fullname.split(' ');
                let shortName = names[0].substring(0, 1) + names[1].substring(0, 1);
                this.shortName = shortName.toUpperCase();
              }

            });

            this._authService.setLogin.next(this.login);
          } else {
            // user is inactive in database
            this.isAuthorized = false;
            this.route.navigate(['failed', { reason: 'disabled' }]);
          }
        }
        else {
          // user does not exist in database
          this.isAuthorized = false;
          this.route.navigate(['failed', { reason: 'not-found' }]);
        }
        this.spinner.hide("auth");
      },
      error: err => {
        this.spinner.hide("auth");
        alert("An error has occurred. Please refresh this page to try again.\n\nIf you continue to see this message, please contact an Admin for assistance.");
      }
    })
  }
}
